import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export const HD_BODYGRAPH_SVG_URL = 'assets/img/human-design/bodygraph-full.svg';

/**
 * Levert de markup van `bodygraph-full.svg` (~135 kB). Eén download per
 * paginaload, gedeeld door elke bodygraph (chart, composite, cycles, picker) en
 * door de opstart-warm-up (StartupWarmupService), zodat de eerste chart niet op dit
 * bestand wacht. Een mislukte download wordt vergeten: de volgende aanvraag
 * probeert opnieuw.
 */
@Injectable({ providedIn: 'root' })
export class HdBodygraphSvgService {
  private readonly http = inject(HttpClient);
  private markup: Promise<string> | undefined;

  load(): Promise<string> {
    this.markup ??= firstValueFrom(this.http.get(HD_BODYGRAPH_SVG_URL, { responseType: 'text' })).catch(
      (error: unknown) => {
        this.markup = undefined;
        throw error;
      },
    );
    return this.markup;
  }
}
